module.exports = "/_next/static/images/connect-6178899c022b63c50c2d4f52314f897a.jpg";